import React from 'react';
import { format } from 'date-fns';
import PropTypes from 'prop-types';
import {
  CompanyDataDiv,
  SectionBox,
} from '../../AdminRoutes/Admin/Companies/CompaniesHome/CompanyHome.styles';

const UserDetailData = ({ user, userData }) => {
  if (!user) {
    return <p>No user data available</p>;
  }
  const formattedCreatedAt = user?.createdAt
    ? format(new Date(user?.createdAt), 'MMMM dd yyyy, HH:mm')
    : 'N/A';
  const formattedUpdatedAt = user?.updatedAt
    ? format(new Date(user?.updatedAt), 'MMMM dd yyyy, HH:mm')
    : 'N/A';
  const formattedLastLogin = user?.lastLogin
    ? format(new Date(user?.lastLogin), 'MMMM dd yyyy, HH:mm')
    : 'N/A';

  return (
    <CompanyDataDiv>
      <SectionBox>
        <h3>User Details</h3>
        <div>
          {(user?.firstName || user?.lastName) && (
            <p>
              <strong>Name:</strong> {user.firstName} {user.lastName}
            </p>
          )}
          {userData?.type === 'Admin' && (
            <>
              {user?.type && (
                <p>
                  <strong>Type:</strong> {user.type}
                </p>
              )}
            </>
          )}
          {user?.email && (
            <p>
              <strong>Email:</strong> {user.email}
            </p>
          )}
          {user?.phone || user?.phoneNumber ? (
            <p>
              <strong>Phone:</strong> {user.phone || user.phoneNumber}
            </p>
          ) : null}
          {user?.company?.[0] && (
            <>
              <p>
                <strong>Company:</strong>{' '}
                {user.company[0]?.companyId?.companyName || 'N/A'}
              </p>
              <p>
                <strong>Role:</strong> {user.company[0]?.role || 'N/A'}
              </p>
            </>
          )}
          {user?.active !== undefined && (
            <p>
              <strong>Active:</strong>{' '}
              {user.active ? 'User is active' : 'User is not active'}
            </p>
          )}
          {user?.accountDetailsEmailSent !== undefined && (
            <p>
              <strong>Account Details Email Sent:</strong>{' '}
              {user.accountDetailsEmailSent
                ? 'User has received account details email'
                : 'User has not received account details email'}
            </p>
          )}
          {formattedCreatedAt && (
            <p>
              <strong>Created At:</strong> {formattedCreatedAt}
            </p>
          )}
          {formattedUpdatedAt && (
            <p>
              <strong>Updated At:</strong> {formattedUpdatedAt}
            </p>
          )}
          {formattedLastLogin && (
            <p>
              <strong>Last Login:</strong> {formattedLastLogin}
            </p>
          )}
        </div>
      </SectionBox>
    </CompanyDataDiv>
  );
};

UserDetailData.propTypes = {
  userData: PropTypes.object,
  user: PropTypes.shape({
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    email: PropTypes.string,
    phone: PropTypes.string,
    type: PropTypes.string,
    accountDetailsEmailSent: PropTypes.bool,
    createdAt: PropTypes.string,
    updatedAt: PropTypes.string,
    lastLogin: PropTypes.string,
    active: PropTypes.bool,
    _id: PropTypes.string,
    phoneNumber: PropTypes.string,
    permissions: PropTypes.arrayOf(PropTypes.string),
    company: PropTypes.arrayOf(
      PropTypes.shape({
        companyId: PropTypes.shape({
          companyName: PropTypes.string,
        }),
        role: PropTypes.string,
      })
    ),
  }),
};

export default UserDetailData;
